export const USER_DETAILS_PAGE__TITLE = 'User details';
export const USER_DETAILS_PAGE__BACK_BUTTON = 'Back';
export const USER_DETAILS_PAGE__NAME_TITLE = 'Name';
export const USER_DETAILS_PAGE__EMAIL_TITLE = 'Email';
export const USER_DETAILS_PAGE__USERNAME_TITLE = 'Username';
export const USER_DETAILS_PAGE__FILTER_TENANT_PLACEHOLDER =
	'Filter by tenant name';

export const USE_ROLE_ACCOUNT_TYPE = 'account.useRoles';
export const USE_ROLE_ACCOUNT_TYPE_LABEL = 'Add To Tenant';
export const INTERNAL_ADMIN_LABEL = 'Namespace Admin';
export const LEGACY_AUTH_TENANT_CLAIM_ONLY_LABEL = 'Claims Only';
export const LEGACY_AUTH_TENANT_READ_ONLY_LABEL = 'Read Only';
export const LEGACY_AUTH_TENANT_EMPLOYEE_LABEL = 'Employee';

export const USER_DETAILS_PAGE__TENANTS_MANAGE_ROLES_BUTTON_TEXT =
	'Manage Roles';
export const USER_DETAILS_PAGE__DELETE_USER_BUTTON_TOOLTIP = 'Delete user';
export const USER_DETAILS_PAGE__DELETE_USER_BUTTON_ALT_TEXT = 'delete user';
export const USER_DETAILS_PAGE__DELETE_CONFIRMATION_TEXT =
	'Are you sure you want to delete this user?';
export const USER_DETAILS_PAGE__DELETE_CONFIRMATION_TEXT_2 =
	'This cannot be undone.';

export const USER_DETAILS_PAGE__EDIT_USER_BUTTON_TOOLTIP = 'Edit user';
export const USER_DETAILS_PAGE__EDIT_USER_BUTTON_ALT_TEXT = 'edit user';
export const USER_DETAILS_PAGE__EDIT_USER_MODAL_TITLE = 'Update User';

export const USER_DETAILS_PAGE__TENANTS_TITLE = 'Assign to Tenant';
export const USER_DETAILS_PAGE__LEGACY_AUTH_TENANT_TITLE =
	'Assign to Tenant with Legacy Roles';
export const USER_DETAILS_PAGE__NAMESPACE_TITLE = 'Assign Namespace Role';

export const USER_DETAILS_PAGE__NAMESPACE_TITLE_EXPLAINER =
	'Removing the namespace role for this user is disabled because you are currently using this role.';

export const CLIENTS_TABLE_TITLE = 'Clients';
export const CLIENTS_TABLE_OPEN_CLIENT_FORM_BUTTON = 'Add Client';
export const CLIENTS_TABLE_CLIENT_ID_LABEL = 'Client ID';
export const CLIENTS_TABLE_TENANT_LABEL = 'Tenant';
export const CLIENTS_TABLE_LEGACY_TENANT_LABEL = 'Legacy Account Type';
export const CLIENTS_TABLE_ERROR_MESSAGE = 'Error loading clients';
export const CLIENTS_TABLE_NOT_AVAILABLE_CELL = 'N/A';

export const CLIENT_FORM__CLIENT_TYPE_LABEL = 'Client Type';
export const CLIENT_FORM__ROLE_LABEL = 'Legacy Account Type';
export const CLIENT_FORM__CLIENT_ID_LABEL = 'Client ID';
export const CLIENT_FORM__TENANT_TYPE__TENANT_LABEL = 'Tenant';
export const CLIENT_FORM__TENANT_TYPE__LEGACY_TENANT_LABEL = 'Legacy Tenant';
export const CLIENT_FORM__TENANT_TYPE__NAMESPACE_LABEL = 'Namespace';
export const CLIENT_FORM__CREATE_CLIENT_BUTTON = 'Create';
export const CLIENT_FORM__CANCEL_BUTTON = 'Cancel';
export const CLIENT_FORM__SUCCESS_CREATE_MESSAGE = 'Client added';
